var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "Form",
        {
          ref: "formItemSearch",
          attrs: { model: _vm.formItem, "label-width": 60 }
        },
        [
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "关键字", prop: "keywords" } },
                        [
                          _c("Input", {
                            attrs: { placeholder: "姓名/手机号" },
                            nativeOn: {
                              keydown: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                $event.preventDefault()
                                return _vm.search.apply(null, arguments)
                              }
                            },
                            model: {
                              value: _vm.formItem.keywords,
                              callback: function($$v) {
                                _vm.$set(_vm.formItem, "keywords", $$v)
                              },
                              expression: "formItem.keywords"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "角色", prop: "role_id" } },
                        [
                          _c(
                            "Select",
                            {
                              model: {
                                value: _vm.formItem.role_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.formItem, "role_id", $$v)
                                },
                                expression: "formItem.role_id"
                              }
                            },
                            _vm._l(_vm.roleList, function(item) {
                              return _c(
                                "Option",
                                { key: item.id, attrs: { value: item.id } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "部门", prop: "department_id" } },
                        [
                          _c(
                            "Select",
                            {
                              on: { "on-change": _vm.departmentChange },
                              model: {
                                value: _vm.formItem.department_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.formItem, "department_id", $$v)
                                },
                                expression: "formItem.department_id"
                              }
                            },
                            _vm._l(_vm.departmentList, function(item) {
                              return _c(
                                "Option",
                                { key: item.id, attrs: { value: item.id } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "职位", prop: "position_id" } },
                        [
                          _c(
                            "Select",
                            {
                              model: {
                                value: _vm.formItem.position_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.formItem, "position_id", $$v)
                                },
                                expression: "formItem.position_id"
                              }
                            },
                            _vm._l(_vm.positionList, function(item) {
                              return _c(
                                "Option",
                                { key: item.id, attrs: { value: item.id } },
                                [_vm._v(_vm._s(item.name))]
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "Col",
                    { attrs: { span: "4" } },
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "员工状态",
                            "label-width": 80,
                            prop: "state"
                          }
                        },
                        [
                          _c(
                            "Select",
                            {
                              model: {
                                value: _vm.formItem.state,
                                callback: function($$v) {
                                  _vm.$set(_vm.formItem, "state", $$v)
                                },
                                expression: "formItem.state"
                              }
                            },
                            [
                              _c("Option", { attrs: { value: "1" } }, [
                                _vm._v("在职")
                              ]),
                              _vm._v(" "),
                              _c("Option", { attrs: { value: "2" } }, [
                                _vm._v("离职")
                              ]),
                              _vm._v(" "),
                              _c("Option", { attrs: { value: "3" } }, [
                                _vm._v("调店")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Row",
            [
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "内部通知单默认接收状态",
                        "label-width": 160,
                        prop: "inside_notice_state"
                      }
                    },
                    [
                      _c(
                        "Select",
                        {
                          model: {
                            value: _vm.formItem.inside_notice_state,
                            callback: function($$v) {
                              _vm.$set(_vm.formItem, "inside_notice_state", $$v)
                            },
                            expression: "formItem.inside_notice_state"
                          }
                        },
                        [
                          _c("Option", { attrs: { value: "1" } }, [
                            _vm._v("是")
                          ]),
                          _vm._v(" "),
                          _c("Option", { attrs: { value: "0" } }, [
                            _vm._v("否")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "Col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "Button",
                    {
                      staticStyle: { "margin-left": "5px" },
                      attrs: { type: "primary" },
                      on: { click: _vm.search }
                    },
                    [_vm._v("查询")]
                  ),
                  _vm._v(" "),
                  _c(
                    "Button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.reset("formItemSearch")
                        }
                      }
                    },
                    [_vm._v("清空筛选")]
                  ),
                  _vm._v(" "),
                  _c(
                    "Button",
                    { attrs: { type: "primary" }, on: { click: _vm.add } },
                    [_vm._v("添加")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticStyle: { width: "100%" } },
        [
          _c("Table", {
            ref: "table",
            attrs: {
              stripe: "",
              loading: _vm.loading,
              border: "",
              columns: _vm.t_head,
              data: _vm.t_data,
              height: _vm.tableHeight
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                "margin-top": "20px",
                display: "flex",
                "justify-content": "flex-end"
              }
            },
            [
              _c("Page", {
                attrs: {
                  total: _vm.pagination.total,
                  "page-size": _vm.pagination.per_page,
                  "show-total": "",
                  "show-elevator": "",
                  "show-sizer": "",
                  transfer: true,
                  "page-size-opts": _vm.pageSizeOpts
                },
                on: {
                  "on-page-size-change": _vm.changeLimit,
                  "on-change": _vm.pageChange
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: { title: _vm.staffModaltitle },
          model: {
            value: _vm.staffModalShow,
            callback: function($$v) {
              _vm.staffModalShow = $$v
            },
            expression: "staffModalShow"
          }
        },
        [
          _c("Alert", { attrs: { type: "success" } }, [
            _vm._v("\n            小提示：" + _vm._s(_vm.desc) + "\n        ")
          ]),
          _vm._v(" "),
          _c(
            "Form",
            {
              ref: "formValidate",
              attrs: {
                model: _vm.staffFormItem,
                rules: _vm.ruleValidate,
                "label-width": 80
              }
            },
            [
              _c(
                "FormItem",
                { attrs: { label: "姓名", prop: "user_name" } },
                [
                  _c("Input", {
                    attrs: { placeholder: "请输入" },
                    model: {
                      value: _vm.staffFormItem.user_name,
                      callback: function($$v) {
                        _vm.$set(_vm.staffFormItem, "user_name", $$v)
                      },
                      expression: "staffFormItem.user_name"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "账号", prop: "phone" } },
                [
                  _c("Input", {
                    attrs: { placeholder: "请输入", maxlength: 11 },
                    model: {
                      value: _vm.staffFormItem.phone,
                      callback: function($$v) {
                        _vm.$set(_vm.staffFormItem, "phone", $$v)
                      },
                      expression: "staffFormItem.phone"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "选择部门", prop: "department_id" } },
                [
                  _c(
                    "Select",
                    {
                      on: { "on-change": _vm.departmentChangeEdit },
                      model: {
                        value: _vm.staffFormItem.department_id,
                        callback: function($$v) {
                          _vm.$set(_vm.staffFormItem, "department_id", $$v)
                        },
                        expression: "staffFormItem.department_id"
                      }
                    },
                    _vm._l(_vm.departmentList, function(item) {
                      return _c(
                        "Option",
                        { key: item.id, attrs: { value: item.id + "" } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "选择职位", prop: "position_id" } },
                [
                  _c(
                    "Select",
                    {
                      model: {
                        value: _vm.staffFormItem.position_id,
                        callback: function($$v) {
                          _vm.$set(_vm.staffFormItem, "position_id", $$v)
                        },
                        expression: "staffFormItem.position_id"
                      }
                    },
                    _vm._l(_vm.positionList, function(item) {
                      return _c(
                        "Option",
                        { key: item.id, attrs: { value: item.id + "" } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "FormItem",
                { attrs: { label: "选择角色", prop: "role_id" } },
                [
                  _c(
                    "Select",
                    {
                      model: {
                        value: _vm.staffFormItem.role_id,
                        callback: function($$v) {
                          _vm.$set(_vm.staffFormItem, "role_id", $$v)
                        },
                        expression: "staffFormItem.role_id"
                      }
                    },
                    _vm._l(_vm.roleList, function(item) {
                      return _c(
                        "Option",
                        { key: item.id, attrs: { value: item.id + "" } },
                        [_vm._v(_vm._s(item.name))]
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "Button",
                {
                  attrs: { type: "text", size: "large" },
                  on: { click: _vm.close }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "Button",
                {
                  attrs: { type: "primary", size: "large" },
                  on: {
                    click: function($event) {
                      _vm.handleSubmit("formValidate")
                    }
                  }
                },
                [_vm._v("确定")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6df9fcb0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6df9fcb0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SystemSetting/System/staffList.vue
// module id = null
// module chunks = 